import { all, takeLatest } from 'redux-saga/effects';
import { LOGGED_IN_SUCCESS, LOGOUT } from '../redux/types/init';
import { logout } from './logout';
import { loggedInSuccess } from './init';
import { SAVE_TRANS, GET_EMANDATE_DETAILS, SAVE_EMANDATE_RESPONSE, SAVE_EMANDATE_TOKEN } from '../redux/types/trans';
import { AIFMOH_HOLDING, AIFMOH_HOLDING_FAILED } from "../redux/types/aifMoh"
import { AUTHENTICATE_USER } from '../redux/types/authenticate';
import { authenticateUser } from './authenticate';
import * as type from '../redux/types/trans';
import { getCartData, getBankData, getAmount, saveTrans, saveTransDetails, getParams, paymentRes } from './trans/cartSaga';
import { GetEmandateDetails, SaveEmandateResponse, SaveEmandateToken, GetAIFMOH } from './trans/transSaga'
import { REMOVE_COOKIE } from '../redux/types/removeCookies';
import { removeCookie } from './removeCookie';
// import { GetEmandateDetails, SaveEmandateResponse, SaveEmandateToken } from './trans/transSaga'

function* rootSaga() {
  yield all([
    takeLatest(type.LUMSUM_AMT, getAmount),
    takeLatest(type.SAVE_TRANS, saveTransDetails),
    takeLatest(type.GET_PARAMS, getParams),
    takeLatest(type.PAYMENT_RES, paymentRes),
    // takeLatest(SAVE_TRANS, saveTrans),
    takeLatest(LOGGED_IN_SUCCESS, loggedInSuccess),
    takeLatest(LOGOUT, logout),
    takeLatest(AUTHENTICATE_USER, authenticateUser),
    takeLatest(GET_EMANDATE_DETAILS, GetEmandateDetails),
    takeLatest(SAVE_EMANDATE_RESPONSE, SaveEmandateResponse),
    takeLatest(SAVE_EMANDATE_TOKEN, SaveEmandateToken),
    takeLatest(AIFMOH_HOLDING, GetAIFMOH),
    takeLatest(REMOVE_COOKIE, removeCookie)

  ]);
}

export default rootSaga;